import { render, staticRenderFns } from "./TeamMemberMange.vue?vue&type=template&id=39bb37d6&scoped=true&"
import script from "./TeamMemberMange.vue?vue&type=script&lang=ts&"
export * from "./TeamMemberMange.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMemberMange.vue?vue&type=style&index=0&id=39bb37d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb37d6",
  null
  
)

export default component.exports